
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-pamong/pejabat-penilai-kinerja",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-pamong/pejabat-penilai-kinerja/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-pamong/pejabat-penilai-kinerja"])
      });
    }
  